import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/a43841af-3ea8-488d-b948-b8cac82a1b00",
        "alt": "An image showing the Pillar anatomy with an icon, a heading and a description in a vertical order."
      }}></img></p>
    <ul>
      <li parentName="ul">{`Icon: An optional visual cue related to the content of the Pillar.`}</li>
      <li parentName="ul">{`Heading: The main title of the Pillar. It should be short and concise.`}</li>
      <li parentName="ul">{`Description: Short text that extends the information provided by the heading.`}</li>
      <li parentName="ul">{`Link: An optional link to extended the information.`}</li>
    </ul>
    <h2>{`Usage`}</h2>
    <p>{`Use pillars to group similar features or benefits together to easily scan and read. Pillars display content in a familiar and recognizable style.`}</p>
    <h3>{`Stacked`}</h3>
    <p>{`Pillars should be stacked to display a list of items that are related to each other. Use consistent pillar sizes within a row or group. A group or a row of content pillars is more visually appealing when the widths and heights of all elements match, so keep the content lenght of each pillar consistent.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/6fd15d68-91cc-446f-a813-c873aad9a8e7" />
    <Caption mdxType="Caption">
      Use a similar content size to achieve a visually balanced layout.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/4b33e84c-841a-43b1-a96b-5cec60ae0353" />
    <Caption mdxType="Caption">
      Don't use different length sizes for the title or the description.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`If displaying an icon, do so for all cards to achieve a visually balanced layout.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/94dc144a-dffa-45a0-a77f-b0b830e669bc" />
    <Caption mdxType="Caption">
      Use icons either for all pillars or none for a visually balanced layout.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/8ddb7a7b-396b-44c2-9cbd-e6a44eb13710" />
    <Caption mdxType="Caption">Don't use icons sparingly.</Caption>
  </Dont>
    </DoDontContainer>
    <p>{`When presenting more than four pillars, we recommend displaying them in multiple rows. You can use the `}<a parentName="p" {...{
        "href": "/components/Grid"
      }}>{`Grid`}</a>{` or the `}<a parentName="p" {...{
        "href": "/components/Stack"
      }}>{`Stack`}</a>{` component to achieve this. We recommend using a grid with 3 or 4 columns and balancing the number of pillars on each row.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/1d031ae9-bf4e-4e19-a7b7-c8cc0b7e5940",
        "alt": "An image showing a group of numerous Pillars stacked in a 3 column grid."
      }}></img></p>
    <h3>{`Pillar and Card`}</h3>
    <p>{`Pillar and Card are both components that are used to present related and/or condensed information. They have distinct use-cases however, with the main differences between them being:`}</p>
    <h4>{`Interaction`}</h4>
    <p>{`Pillars are used mainly for non-interactive content and might include an optional link for extended information. On the other hand, Cards are primarily navigational elements.`}</p>
    <h4>{`Hierarchy`}</h4>
    <p>{`Cards should be used for noteworthy information to immediately draw user attention. Pillars, on the other hand, should be used for lower priority information compared to Cards.`}</p>
    <h4>{`Group size`}</h4>
    <p>{`Cards should be used in small groups (3, 4 or 5 items maximum), whereas Pillars can be used in larger (more than 5 items) or smaller groups. As users encounter an increasing number of items within a group, the distinctiveness of each individual element diminishes.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/ec95d12e-9202-4488-97b8-42656f638937" />
    <Caption mdxType="Caption">Pillars are more suitable for groups of 5 or more items.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/c0775fcd-7ef9-430d-9315-d3fdbd55947f" />
    <Caption mdxType="Caption">
      Don't use Cards for groups of 5 or more items. Use them sparingly in
      groups of 3 or 4.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Options`}</h2>
    <h3>{`Align`}</h3>
    <p>{`Pillars can be aligned to the start or center of the container. Aligning to the start is the default and recommended behavior. Use center alignment only when displaying a maximum of 4 pillars and the overall page design calls for this alignment, so that the content is visually balanced and easy to scan.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/964e82b4-ea5f-436c-aece-bc0b82f49852" />
    <Caption mdxType="Caption">
      Center align pillars when in groups of 3 or 4 and if their title and
      descriptions are short.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/a9be67a6-79e0-460b-b3e3-44bb72e096a2" />
    <Caption mdxType="Caption">Don't use center alignment when in groups of 5 or more.</Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Card"
        }}>{`Card`}</a>{`: To display navigational related content with higher visual weight.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/River"
        }}>{`River`}</a>{`: To display a list of content items with a visual asset.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/CTABanner"
        }}>{`CTABanner`}</a>{`: To display a single block of content to draw attention or create urgency around a user action.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/UnorderedList"
        }}>{`UnorderedList`}</a>{` or the `}<a parentName="li" {...{
          "href": "/components/OrderedList"
        }}>{`OrderedList`}</a>{`: To display a list of plain content items.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      